<template>
    <div class="m-calendar__group" v-if="cell.start_at >= dateNow.add(30, 'minute') && !cell.booked">
        <button class="m-calendar__button r-button"
                :disabled="!cell.appointment || (cell.disabled && cell.chosen)"
                type="button"
                v-html="cell.start_at.format('HH:mm')"
                @click="customerClickCell(cell)">
        </button>
    </div>
</template>

<script>
	import {mapGetters, mapMutations, mapState} from 'vuex';

	import CalendarPopup from "../desktop/CalendarPopup.vue";

    export default {
		components: {CalendarPopup},
		name: 'CalendarModalCell',
		props: {
			cell: {
				type: Object,
				required: true
			}
		},
        data: () => ({
            user: window.laravel.user,
        }),
        computed: {
            ...mapState([
                'dateNow'
            ])
        },
		methods: {
			...mapMutations([
				'chooseCell',
				'makeAppointment',
				'showPopupInfo'
			]),
            customerClickCell(cell) {
			    this.makeAppointment(cell);
                this.showPopupInfo(cell);
            }
		},
	}
</script>


